import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import './App.css';
import Home from './pages/Home';
import OurStory from './pages/OurStory';
import Schedule from './pages/Schedule';
import Location from "./pages/Location";
import Accommodation from './pages/Accommodation';
import ThingsToDo from './pages/ThingsToDo';
import Registry from './pages/Registry';
import FAQ from './pages/FAQ';
import RSVP from './pages/RSVP';
import NavBar from "./NavBar";
import ScrollToTop from "./ScrollToTop";
import { createTheme, ThemeProvider } from "@mui/material";

function App() {
  const theme = createTheme({
    typography: {
      fontFamily: "Pinyon",
    }
  });
  return (
    <ThemeProvider theme={theme}>
      <div style={{ backgroundColor: "inherit", color: "inherit" }}>
        <Router>
          <ScrollToTop />
          <NavBar />
          <div className="content">
            <Routes>
              <Route path="/" element={<Home />}></Route>
              <Route path="/ourstory" element={<OurStory />}></Route>
              <Route path="/schedule" element={<Schedule />}></Route>
              <Route path="/location" element={<Location />}></Route>
              <Route path="/accommodation" element={<Accommodation />}></Route>
              <Route path="/thingstodo" element={<ThingsToDo />}></Route>
              <Route path="/registry" element={<Registry />}></Route>
              <Route path="/faq" element={<FAQ />}></Route>
              <Route path="/rsvp" element={<RSVP />}></Route>
            </Routes>
          </div>
          <footer style={{ display: "flex", justifyContent: "center", alignItems: "center" }}>
            <p style={{ textAlign: "center" }}>© 2026 Adam Baker - Full Stack Developer Extraordinaire</p>
          </footer>
        </Router>
      </div>
    </ThemeProvider>
  );
}

export default App;
